// Constants
const radius = 50;
const squareSize = 6.5;
const prec = 19.55;
const fuzzy = 0.001;

// Function to generate a random color with a specified hue range
function randomColorWithHueRange(minHue, maxHue) {
    const hue = randomNumber(minHue, maxHue);
    const saturation = "70%"; // You can adjust saturation and lightness values
    const lightness = "70%"; // based on your preference.
    return `hsl(${hue}, ${saturation}, ${lightness})`;
}

// Function to generate a random number between min and max (inclusive)
function randomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

// Calculate the circumference of a circle with given radius
function getCircumference(radius) {
    return 2 * Math.PI * radius;
}

// Create and append a square div element to a disco ball
function createAndAppendSquare(discoBall, x, y, z, t, i, darkHue, lightHue) {
    const square = document.createElement("div");
    const squareTile = document.createElement("div");

    squareTile.style.width = `${squareSize}px`;
    squareTile.style.height = `${squareSize}px`;
    squareTile.style.transformOrigin = "0 0 0";
    squareTile.style.webkitTransformOrigin = "0 0 0";
    squareTile.style.webkitTransform = `rotate(${i}rad) rotateY(${t}rad)`;

    if ((t > 1.3 && t < 1.9) || (t < -1.3 && t > -1.9)) {
        squareTile.style.backgroundColor = randomColorWithHueRange(darkHue, lightHue);
    } else {
        squareTile.style.backgroundColor = randomColorWithHueRange(darkHue, lightHue);
    }

    square.appendChild(squareTile);
    square.className = "disco-square";
    squareTile.style.webkitAnimation = "reflect 2s linear infinite";
    squareTile.style.webkitAnimationDelay = `${randomNumber(0, 20) / 10}s`;
    squareTile.style.animation = "reflect 2s linear infinite";
    squareTile.style.animationDelay = `${randomNumber(0, 20) / 10}s`;
    squareTile.style.backfaceVisibility = "hidden";

    square.style.webkitTransform = `translateX(${Math.ceil(x)}px) translateY(${y}px) translateZ(${z}px)`;
    square.style.transform = `translateX(${x}px) translateY(${y}px) translateZ(${z}px)`;

    discoBall.appendChild(square);
}

// Main loop to create the disco balls
function createDiscoBalls(className) {
    const discoBalls = document.querySelectorAll(`.${className}`);

    discoBalls.forEach(discoBall => {
        const inc = (Math.PI - fuzzy) / prec;
        const darkHue = parseInt(discoBall.dataset.darkHue, 10) || randomNumber(0, 180);
        const lightHue = parseInt(discoBall.dataset.lightHue, 10) || randomNumber(181, 360);

        for (let t = fuzzy; t < Math.PI; t += inc) {
            const z = radius * Math.cos(t);
            const currentRadius = Math.abs(
                (radius * Math.cos(0) * Math.sin(t)) - (radius * Math.cos(Math.PI) * Math.sin(t))
            ) / 2.5;
            const circumference = getCircumference(currentRadius);
            const squaresThatFit = Math.floor(circumference / squareSize);
            const angleInc = (Math.PI * 2 - fuzzy) / squaresThatFit;

            for (let i = angleInc / 2 + fuzzy; i < Math.PI * 2; i += angleInc) {
                const x = radius * Math.cos(i) * Math.sin(t);
                const y = radius * Math.sin(i) * Math.sin(t);
                createAndAppendSquare(discoBall, x, y, z, t, i, darkHue, lightHue);
            }
        }
    });
}

// Start creating the disco balls (provide the class name for the disco balls)
createDiscoBalls("disco-ball");
